import { PageHeader } from 'ui/pageHeader';
import { CampaignsCalendar } from './components/calendar';
import { useGetCampaignsCalendarQuery } from './hooks';
import { ErrorStatePageError } from 'ui/illustrations';
import { PlaceholderState } from 'ui/indexPages/PlaceholderState';

export const CampaignsCalendarPage = () => {
  const { data, isError, isLoading } = useGetCampaignsCalendarQuery();
  return (
    <>
      <PageHeader data-test="send-calendar-header">Send Calendar</PageHeader>
      {isError ? (
        <PlaceholderState
          data-test="campaign-calendar-empty-state"
          id="campaign-calendar-empty-state"
          Illustration={ErrorStatePageError}
          title={'We’ve ran into a snag!'}
        >
          There was an error loading campaign events. Please try again later.
        </PlaceholderState>
      ) : (
        <CampaignsCalendar events={data} isLoading={isLoading} />
      )}
    </>
  );
};
